import BrandWorldHeroSection from "./BrandWorldHeroSection"
import BrandWorldCategories from "./components/BrandWorldCategories"
import CircleAnimations from "./components/CircleAnimations"
import React from "react"

function BrandWorldHeaderSection() {
	return (
		<section className="brand-header-section-container">
			<div className=" brand-world-hero d-flex align-items-center justify-content-center flex-column">
				<BrandWorldHeroSection />
			</div>
			<div style={{backgroundColor: "#212529", marginTop: "80px"}}
				className=" d-flex align-items-center justify-content-center">
				<BrandWorldCategories />
			</div>
			<CircleAnimations />
		</section>
	)
}

export default BrandWorldHeaderSection
